module.exports = __webpack_public_path__ + "img/kkb.831cf9e0.png";